import { render, staticRenderFns } from "./PelatihanNarasumber.vue?vue&type=template&id=5bc18c13"
import script from "./PelatihanNarasumber.vue?vue&type=script&lang=js"
export * from "./PelatihanNarasumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports